export const MY_LOCATION_FETCH_REQUEST = 'my-location-fetch-request';
export const MY_LOCATION_FETCH_SUCCESS = 'my-location-fetch-success';
export const MY_LOCATION_FETCH_FAILURE = 'my-location-fetch-failure';